import React from 'react';
import { NextPage } from 'next';

import { tariffs } from '@r1-frontend/api-domru/api-content/v1/cities/tariffs';
import {
    TResponseDto as TTariffsResponseDto,
} from '@r1-frontend/api-domru/api-content/v1/cities/tariffs/dto/ResponseDto';
import { domofonAction } from '@r1-frontend/api-domru/api-content/v1/domofon-action';
import {
    TResponseDto as TDomofonActionResponseDto,
} from '@r1-frontend/api-domru/api-content/v1/domofon-action/dto/ResponseDto';

import { EExpandShopItems, EShopCategory, getShopItems, IShopItem } from '~/src/api/content/shop/getShopItems';
import { IBundle } from '~/src/entities/tariff';
import Layout from '~/src/features/_layout';
import MovixnewLanding from '~/src/features/movix-new';
import { getPageDataSeo } from '~/src/features/movix-new/utils';
import { prepareTariffsZasmotris } from '~/src/features/movix-new/utils/prepareTariffsZasmotris';
import { initialProps } from '~/src/helpers/basePageFunc';
import { getCookie } from '~/src/helpers/cookie';
import getRequester from '~/src/helpers/getRequester';
import { saveIntercomAction } from '~/src/store/actions/intercom';
import selectProviderId from '~/src/store/selectors/selectProviderId';

interface IProps {
    pageDataSeo: ReturnType<typeof getPageDataSeo>,
    cardsInfo: IShopItem[],
    zasmotrisInfo: IBundle[],
}

const MovixLandingPage: NextPage<IProps> = ({ pageDataSeo, cardsInfo, zasmotrisInfo }) => {
    return (
        <Layout
            title={pageDataSeo.title}
            description={pageDataSeo.description}
            withMenu={true}
            withChat={true}
            withFooter={true}
        >
            <MovixnewLanding
                cardsInfo={cardsInfo}
                zasmotrisInfo={zasmotrisInfo}
            />
        </Layout>
    );
};

MovixLandingPage.getInitialProps = async(options) => {
    const { validatedAccessToken } = await initialProps(options, { isNeedAuthData: true });
    const { req, store } = options;

    const state = store.getState();
    const {
        city: {
            currentCity,
        },
    } = state;

    const providerId = Number(getCookie('providerId', req) || selectProviderId(state));

    const pageDataSeo = getPageDataSeo(currentCity);

    const doRequest = getRequester(options.req);

    const [domofonActionResponse, tariffsResponse, cardsInfo] = await Promise.all([
        doRequest.apiContent<TDomofonActionResponseDto>(domofonAction()),
        doRequest.apiContent<TTariffsResponseDto>({
            ...tariffs({ providerId }),
            withProvider: false,
        }),
        getShopItems(
            providerId,
            validatedAccessToken,
            EShopCategory.Decoders,
            [
                EExpandShopItems.Category,
                EExpandShopItems.Labels,
                EExpandShopItems.Props,
            ],
            { 'filter[eq]': 'tv-pristavka-movix-model-2021' },
        ),
    ]);

    if (domofonActionResponse.isSuccess) {
        store.dispatch(saveIntercomAction(domofonActionResponse.payload.items[0]));
    }

    const zasmotrisInfo = tariffsResponse?.isSuccess
        ? prepareTariffsZasmotris(tariffsResponse.payload.bundles)
        : [];

    return ({
        pageDataSeo,
        cardsInfo,
        zasmotrisInfo,
    });
};

export default MovixLandingPage;
